'use strict';
angular.module('atex.dam').controller('DamPopupWindowController', [ '$rootScope', '$scope', '$modal', function($rootScope, $scope, $modal) {

  var view = atex.onecms.ObjectUtils.getByPath($scope.field, "value/view") || "";
  $scope.icon = atex.onecms.ObjectUtils.getByPath($scope.field, "value/icon") || "";

  $scope.create = function (queryModel) {

    var modalScope = $rootScope.$new();
    modalScope.queryModel = queryModel;
    modalScope.data = [];

    var fieldName = atex.onecms.ObjectUtils.getByPath($scope.field, "value/model/attribute") || "";
    modalScope.fieldName = fieldName;
    modalScope.field = $scope.field;

    var modal = $modal({
      show: true,
      scope: modalScope,
      template: 'views/'+ view + '.html',
      modalClass: 'dam-modal-edit confirm-modal ng-cloak',
      backdrop: 'static',
      keyboard: false
    });

    var destroyModal = function () {
      modal.then(function (modalEl) {
        modalEl.on('hidden.bs.modal', function () {
          modalScope.$destroy();
          angular.element(this).remove();
        });
        modalEl.modal('hide');
      });
    };
    modalScope.doCancel = function () {
      destroyModal();
    };
    modalScope.doSave = function () {
      destroyModal();
    };
  };

}]);

angular.module('atex.dam').directive('damPopupWindow', function () {
  return {
    restrict: 'CE',
    templateUrl: 'js/dam/widgets/dam-popup-window/dam-popup-window.html',
    scope: true,
    replace:true,
    controller: 'DamPopupWindowController',

    link: function (scope, element, attrs) {

    }
  };
});

